._TourBlinkingHighlight_numrq_1 {
  --animation-color: 235, 34, 34;
  position: absolute;
  pointer-events: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  z-index: 100000000001 !important;
  overflow: hidden;
  border-radius: 4px;
  animation-name: _blinking-highlight_numrq_1;
  animation-duration: 1600ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear; }

@keyframes _blinking-highlight_numrq_1 {
  0% {
    box-shadow: 0 0 7px 3px rgba(var(--animation-color), 0.4);
    border: 2px solid rgba(var(--animation-color), 1); }
  50% {
    box-shadow: none;
    border: 2px solid rgba(var(--animation-color), 0.5); }
  100% {
    box-shadow: 0 0 7px 3px rgba(var(--animation-color), 0.4);
    border: 2px solid rgba(var(--animation-color), 1); } }
